module.exports = __webpack_public_path__ + "static/img/main_point_img06.784b44d8.svg";